export default __webpack_public_path__ + "static/media/up-down-arrow.d6c81cf0.svg";